var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g6, _g7, _path9, _path10, _path11, _path12, _path13, _g8, _g9, _g10, _g11, _path14, _path15, _g12, _path16, _path17, _g13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyPhase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 892.88 500.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .privacy-disable-rect{\n        fill: #edeef0;\n      }\n      .privacy-disable-rect:hover {\n        pointer-events: none;\n        fill: #edeef0;  \n      }\n      .cls-1-privacy-p1, .cls-2-privacy-p1, .cls-3-privacy-p1, .cls-4-privacy-p1, .cls-5-privacy-p1, .cls-6-privacy-p1, .cls-7-privacy-p1 {\n        stroke: #1f3762;\n      }\n\n      .cls-1-privacy-p1, .cls-8-privacy-p1 {\n        fill: none;\n      }\n\n      .cls-2-privacy-p1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3-privacy-p1, .cls-9-privacy-p1 {\n        fill: #fff;\n      }\n\n      .cls-8-privacy-p1, .cls-10-privacy-p1, .cls-11-privacy-p1, .cls-9-privacy-p1, .cls-12-privacy-p1 {\n        stroke-width: 0px;\n      }\n\n      .cls-4-privacy-p1 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5-privacy-p1 {\n        stroke-width: .05px;\n      }\n\n      .cls-5-privacy-p1, .cls-10-privacy-p1, .cls-7-privacy-p1 {\n        fill: #1f3762;\n      }\n\n      .cls-11-privacy-p1 {\n        fill: #333;\n      }\n\n      .cls-6-privacy-p1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-12-privacy-p1 {\n        fill: #3a414a;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17619.16,
    y1: 3396.12,
    x2: 17619.16,
    y2: 3276.12,
    gradientTransform: "translate(-17163.86 3556.62) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a3ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5faaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 17370.3,
    y1: 3148.33,
    x2: 17370.3,
    y2: 3181.93,
    gradientTransform: "translate(-17163.86 3556.62) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9f9f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 17850.3,
    y1: 3148.33,
    x2: 17850.3,
    y2: 3181.93,
    gradientTransform: "translate(-17163.86 3556.62) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9f9f9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-privacy-p1",
    d: "M284.19,6.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "cls-12-privacy-p1",
    d: "M335.2,62.3l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM332.62,55.58l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "cls-12-privacy-p1",
    d: "M343.35,49.13c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM343.96,50.76c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-12-privacy-p1",
    d: "M358.49,62.3h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    className: "cls-12-privacy-p1",
    d: "M365.01,46.62v-2.04h2.17v2.04h-2.17ZM365.01,62.3v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-12-privacy-p1",
    d: "M375.26,50.83c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    className: "cls-12-privacy-p1",
    d: "M387.76,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM391.29,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "cls-12-privacy-p1",
    d: "M405.34,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "cls-12-privacy-p1",
    d: "M414.92,49.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM414.85,60.94c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "cls-12-privacy-p1",
    d: "M434.2,62.57c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-12-privacy-p1",
    d: "M449.88,49.13c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM449.34,60.94c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-2",
    "data-name": "x",
    className: "cls-12-privacy-p1",
    d: "M461.43,49.13c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM462.04,50.76c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    className: "cls-12-privacy-p1",
    d: "M478.81,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM472.5,58.7c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-2",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M486.82,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-2",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M496.4,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM499.93,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "A-2",
    "data-name": "A",
    className: "cls-12-privacy-p1",
    d: "M516.5,50.83c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-2",
    "data-name": "D",
    className: "cls-12-privacy-p1",
    d: "M528.99,49.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM528.92,60.94c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    className: "cls-12-privacy-p1",
    d: "M543.73,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-3",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M553.37,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-3",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M562.94,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM566.47,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-2",
    "data-name": "H",
    className: "cls-12-privacy-p1",
    d: "M577.68,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-4",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M587.32,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-privacy-p1",
    d: "M455.32,113.5v31.13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-privacy-p1",
    d: "M455.82,113.52h-1v-.52h1v.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-privacy-p1",
    d: "M455.32,159.4l-4.64-14.27h9.27l-4.63,14.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-privacy-p1",
    d: "M206.94,357.82h-1v-42.86h1v42.86ZM287.44,221h-74.98l-.88.07-.84.2-.8.33-.73.45-.65.56-.57.64-.45.74-.33.8-.2.84-.07.88v56.44h-1v-56.48l.08-1,.24-1,.4-.93.52-.88.66-.77.78-.66.87-.54.94-.4,1-.22,1-.08h75v1.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-privacy-p1",
    d: "M287.94,220.5l.06.5h-.57v-1h.57l-.06.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-privacy-p1",
    d: "M287.96,220.5l.07.52h-.63v-1.05h.63l-.07.53ZM287.46,220.02v.95h.5l-.04-.47.05-.48h-.51Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-privacy-p1",
    d: "M206.44,372.57l-4.63-14.26h9.27l-4.64,14.26Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-privacy-p1",
    d: "M206.44,374.19l-5.32-16.38h10.65l-5.33,16.38ZM202.5,358.81l3.94,12.14,3.95-12.15h-7.89Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I",
    className: "cls-11-privacy-p1",
    d: "M85.33,291.41c0,2.96-1.7,4.52-4,5.19l4.96,7.7h-4.37l-4.22-6.96h-4.52v6.96h-3.85v-18.37c6.89.3,16.07-1.7,16,5.48ZM73.18,294.37c3.56-.15,8.3.89,8.3-2.81s-4.89-2.37-8.3-2.59v5.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "cls-11-privacy-p1",
    d: "M94.89,289.93c4.74,0,7.11,2.67,7.11,7.33s-2.59,7.33-7.19,7.33-7.04-2.67-7.04-7.33,2.52-7.33,7.11-7.33ZM94.81,302.07c2.59,0,3.33-2.07,3.33-4.81,0-2.96-.74-4.81-3.19-4.81s-3.33,1.93-3.33,4.81c0,2.67.74,4.81,3.19,4.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "cls-11-privacy-p1",
    d: "M109.26,304.59c-6.44.07-4.3-8.37-4.67-14.37h3.7c.52,4.22-1.7,11.11,2.44,11.63,4.44-.37,2.59-7.19,2.96-11.63h3.7l.07,14.07h-3.48c-.15-.89.07-2.07-.22-2.81-.89,1.85-2.07,3.11-4.52,3.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "cls-11-privacy-p1",
    d: "M127.7,304.07c-2.67,1.04-6.44.52-6.44-3.11v-8.3h-1.78v-2.44h2l1.11-3.33h2.3v3.33h2.67v2.44h-2.67v7.33c-.07,1.7,1.19,2.3,2.81,1.85v2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-11-privacy-p1",
    d: "M129.85,287.7v-2.74h3.7v2.74h-3.7ZM129.85,304.3v-14.07h3.7v14.07h-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-11-privacy-p1",
    d: "M145.41,289.93c6.44-.07,4.3,8.37,4.67,14.37h-3.7c-.52-4.22,1.7-11.63-2.52-11.63s-2.52,7.19-2.89,11.63h-3.7l-.07-14.07h3.48c.15.89-.07,2.07.22,2.81.89-1.93,2.07-3.04,4.52-3.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-11-privacy-p1",
    d: "M165.33,300.74c-.96,2.22-2.74,3.93-6.07,3.85-4.44-.15-6.59-2.74-6.59-7.41s2.22-7.26,6.67-7.26,6.15,3.33,6.22,8h-9.04c0,2.3.59,4.07,2.89,4.15,1.33,0,2.22-.52,2.52-1.63l3.41.3ZM162,295.63c.37-3.41-4.22-4.67-5.19-1.56-.15.44-.3.96-.3,1.56h5.48"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "O-2",
    "data-name": "O",
    className: "cls-11-privacy-p1",
    d: "M187.56,300.74c-.96,2.22-2.74,3.93-6.07,3.85-4.44-.15-6.59-2.74-6.59-7.41s2.22-7.26,6.67-7.26,6.15,3.33,6.22,8h-9.04c0,2.3.59,4.07,2.89,4.15,1.33,0,2.22-.52,2.52-1.63l3.41.3ZM184.22,295.63c.37-3.41-4.22-4.67-5.19-1.56-.15.44-.3.96-.3,1.56h5.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-2",
    "data-name": "N",
    className: "cls-11-privacy-p1",
    d: "M198.67,289.93c6.44-.07,4.3,8.37,4.67,14.37h-3.7c-.52-4.22,1.7-11.63-2.52-11.63s-2.52,7.19-2.89,11.63h-3.7l-.07-14.07h3.48c.15.89-.07,2.07.22,2.81.89-1.93,2.07-3.04,4.52-3.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "cls-11-privacy-p1",
    d: "M213.33,292.67c-4.37,0-2.52,7.19-2.89,11.63h-3.7v-19.33h3.7l-.07,8.07c.89-1.93,2.07-3.04,4.52-3.11,6.37-.07,4.3,8.37,4.67,14.37h-3.7c-.52-4.22,1.7-11.63-2.52-11.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "cls-11-privacy-p1",
    d: "M230.96,301.78c-1.19,1.41-2.22,2.89-4.74,2.81-2.74-.07-4.3-1.48-4.3-4.3-.07-4.44,4.07-4.67,8.59-4.52.07-1.93-.22-3.48-2.07-3.48-1.33.07-1.93.67-2.07,2l-3.85-.15c.52-2.81,2.67-4.3,6.07-4.22s5.48,1.63,5.56,5.04l.07,6.07c-.07,1.04.89,1.33,1.85,1.11v2c-2.22.59-5.26.37-5.11-2.37ZM227.41,302c2.15,0,3.19-1.78,3.11-4.22-2.37,0-4.89-.22-4.81,2.22,0,1.26.59,2,1.7,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-3",
    "data-name": "N",
    className: "cls-11-privacy-p1",
    d: "M245.93,289.93c6.44-.07,4.3,8.37,4.67,14.37h-3.7c-.52-4.22,1.7-11.63-2.52-11.63s-2.52,7.19-2.89,11.63h-3.7l-.07-14.07h3.48c.15.89-.07,2.07.22,2.81.89-1.93,2.07-3.04,4.52-3.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-11-privacy-p1",
    d: "M266.22,299.63c-.52,3.11-2.81,4.96-6.37,4.96-4.37,0-6.22-2.81-6.67-7.26-.89-8.15,11.41-10.15,12.89-2.67l-3.63.15c-.15-1.41-1.11-2.37-2.59-2.37-2.22,0-2.59,2.07-2.81,4.74-.44,5.48,4.81,6.44,5.48,2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-3",
    "data-name": "O",
    className: "cls-11-privacy-p1",
    d: "M280.67,300.74c-.96,2.22-2.74,3.93-6.07,3.85-4.44-.15-6.59-2.74-6.59-7.41s2.22-7.26,6.67-7.26,6.15,3.33,6.22,8h-9.04c0,2.3.59,4.07,2.89,4.15,1.33,0,2.22-.52,2.52-1.63l3.41.3ZM277.33,295.63c.37-3.41-4.22-4.67-5.19-1.56-.15.44-.3.96-.3,1.56h5.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "cls-11-privacy-p1",
    d: "M298.07,292.67c-3.93.67-2.07,7.41-2.52,11.63h-3.63v-7.93c.07-2-.37-3.63-2.15-3.7-3.93.74-2,7.41-2.44,11.63h-3.7l-.07-14.07h3.48c.15.89-.07,2.07.22,2.81.74-3.93,7.48-4.15,8,0,.96-1.63,1.78-3.19,4.37-3.11,6.07.07,3.78,8.59,4.22,14.37h-3.63v-7.93c-.07-1.85-.37-3.56-2.15-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-4",
    "data-name": "O",
    className: "cls-11-privacy-p1",
    d: "M319.18,300.74c-.96,2.22-2.74,3.93-6.07,3.85-4.44-.15-6.59-2.74-6.59-7.41s2.22-7.26,6.67-7.26,6.15,3.33,6.22,8h-9.04c0,2.3.59,4.07,2.89,4.15,1.33,0,2.22-.52,2.52-1.63l3.41.3ZM315.85,295.63c.37-3.41-4.22-4.67-5.19-1.56-.15.44-.3.96-.3,1.56h5.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-4",
    "data-name": "N",
    className: "cls-11-privacy-p1",
    d: "M330.3,289.93c6.44-.07,4.3,8.37,4.67,14.37h-3.7c-.52-4.22,1.7-11.63-2.52-11.63s-2.52,7.19-2.89,11.63h-3.7l-.07-14.07h3.48c.15.89-.07,2.07.22,2.81.89-1.93,2.07-3.04,4.52-3.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-2",
    "data-name": "L",
    className: "cls-11-privacy-p1",
    d: "M345.04,304.07c-2.67,1.04-6.44.52-6.44-3.11v-8.3h-1.78v-2.44h2l1.11-3.33h2.3v3.33h2.67v2.44h-2.67v7.33c-.07,1.7,1.19,2.3,2.81,1.85v2.22"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-privacy-p1",
    d: "M686.94,357.82h-1v-39.8h1v39.8ZM681.46,220.08l1,.23.93.38.87.54.78.66.66.77.54.88.4.94.22,1,.08,1v59.53h-1v-59.5l-.07-.88-.2-.84-.32-.8-.45-.74-.56-.65-.65-.57-.74-.45-.8-.33-.84-.2-.88-.07h-57.23v-1h57.27l.99.1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-privacy-p1",
    d: "M623.2,221h-.57l.06-.5-.06-.5h.58v1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-privacy-p1",
    d: "M623.23,221.02h-.63l.07-.52-.06-.53h.63v1.05ZM622.66,220.02l.06.48-.06.47h.52v-.95h-.52Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-privacy-p1",
    d: "M686.44,372.57l-4.63-14.26h9.27l-4.64,14.26Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5-privacy-p1",
    d: "M686.44,374.19l-5.32-16.38h10.65l-5.33,16.38ZM682.5,358.81l3.94,12.14,3.95-12.15h-7.89Z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "cls-11-privacy-p1",
    d: "M554.55,298.09c0,3.93,1.56,6.44,5.41,6.52,2.74.07,4-1.63,4.81-3.48l3.33,1.26c-1.26,3.11-3.78,5.26-8.15,5.26-6.07,0-8.89-3.41-9.26-9.56-.52-8.15,8.07-11.56,14.52-7.93,1.33.74,2.15,2.15,2.67,3.7l-3.41.89c-.59-1.85-2.22-3.04-4.59-3.04-3.85,0-5.26,2.52-5.33,6.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "cls-11-privacy-p1",
    d: "M578.78,296.24c-2.89-.89-4.44.96-4.44,4.22v6.89h-3.7l-.07-14.07h3.48c.15.96-.07,2.15.22,2.96.44-2.07,2-3.93,4.52-3.04v3.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-2",
    "data-name": "M",
    className: "cls-11-privacy-p1",
    d: "M581,290.76v-2.74h3.7v2.74h-3.7ZM581,307.35v-14.07h3.7v14.07h-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-3",
    "data-name": "L",
    className: "cls-11-privacy-p1",
    d: "M595.07,307.13c-2.67,1.04-6.44.52-6.44-3.11v-8.3h-1.78v-2.44h2l1.11-3.33h2.3v3.33h2.67v2.44h-2.67v7.33c-.07,1.7,1.19,2.3,2.81,1.85v2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-3",
    "data-name": "M",
    className: "cls-11-privacy-p1",
    d: "M597.22,290.76v-2.74h3.7v2.74h-3.7ZM597.22,307.35v-14.07h3.7v14.07h-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-2",
    "data-name": "R",
    className: "cls-11-privacy-p1",
    d: "M616.85,302.68c-.52,3.11-2.81,4.96-6.37,4.96-4.37,0-6.22-2.81-6.67-7.26-.89-8.15,11.41-10.15,12.89-2.67l-3.63.15c-.15-1.41-1.11-2.37-2.59-2.37-2.22,0-2.59,2.07-2.81,4.74-.44,5.48,4.81,6.44,5.48,2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q-2",
    "data-name": "Q",
    className: "cls-11-privacy-p1",
    d: "M627.44,304.83c-1.19,1.41-2.22,2.89-4.74,2.81-2.74-.07-4.3-1.48-4.3-4.3-.07-4.44,4.07-4.67,8.59-4.52.07-1.93-.22-3.48-2.07-3.48-1.33.07-1.93.67-2.07,2l-3.85-.15c.52-2.81,2.67-4.3,6.07-4.22s5.48,1.63,5.56,5.04l.07,6.07c-.07,1.04.89,1.33,1.85,1.11v2c-2.22.59-5.26.37-5.11-2.37ZM623.89,305.05c2.15,0,3.19-1.78,3.11-4.22-2.37,0-4.89-.22-4.81,2.22,0,1.26.59,2,1.7,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "cls-11-privacy-p1",
    d: "M634.26,307.35v-19.33h3.7v19.33h-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "cls-11-privacy-p1",
    d: "M640.11,307.87l3.78-19.85h3.11l-3.78,19.85h-3.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-4",
    "data-name": "L",
    className: "cls-11-privacy-p1",
    d: "M655.74,307.13c-2.67,1.04-6.44.52-6.44-3.11v-8.3h-1.78v-2.44h2l1.11-3.33h2.3v3.33h2.67v2.44h-2.67v7.33c-.07,1.7,1.19,2.3,2.81,1.85v2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-4",
    "data-name": "M",
    className: "cls-11-privacy-p1",
    d: "M657.89,290.76v-2.74h3.7v2.74h-3.7ZM657.89,307.35v-14.07h3.7v14.07h-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-2",
    "data-name": "S",
    className: "cls-11-privacy-p1",
    d: "M679.74,295.72c-3.93.67-2.07,7.41-2.52,11.63h-3.63v-7.93c.07-2-.37-3.63-2.15-3.7-3.93.74-2,7.41-2.44,11.63h-3.7l-.07-14.07h3.48c.15.89-.07,2.07.22,2.81.74-3.93,7.48-4.15,8,0,.96-1.63,1.78-3.19,4.37-3.11,6.07.07,3.78,8.59,4.22,14.37h-3.63v-7.93c-.07-1.85-.37-3.56-2.15-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-5",
    "data-name": "O",
    className: "cls-11-privacy-p1",
    d: "M700.85,303.8c-.96,2.22-2.74,3.93-6.07,3.85-4.44-.15-6.59-2.74-6.59-7.41s2.22-7.26,6.67-7.26,6.15,3.33,6.22,8h-9.04c0,2.3.59,4.07,2.89,4.15,1.33,0,2.22-.52,2.52-1.63l3.41.3ZM697.52,298.68c.37-3.41-4.22-4.67-5.19-1.56-.15.44-.3.96-.3,1.56h5.48"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "cls-11-privacy-p1",
    d: "M719.52,297.13c.07-2.15-5.19-2.52-5.26-.3,1.11,3.41,8.74.52,8.81,6.37.07,6.15-12.15,5.63-12.74.67l3.19-.52c.3,1.41,1.48,1.85,3.26,1.85,2.44.59,4.22-2.22,1.78-3.04-3.19-1.04-7.56-.81-7.7-4.89-.15-5.93,11.41-5.48,11.93-.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-6",
    "data-name": "O",
    className: "cls-11-privacy-p1",
    d: "M737.89,303.8c-.96,2.22-2.74,3.93-6.07,3.85-4.44-.15-6.59-2.74-6.59-7.41s2.22-7.26,6.67-7.26,6.15,3.33,6.22,8h-9.04c0,2.3.59,4.07,2.89,4.15,1.33,0,2.22-.52,2.52-1.63l3.41.3ZM734.55,298.68c.37-3.41-4.22-4.67-5.19-1.56-.15.44-.3.96-.3,1.56h5.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-5",
    "data-name": "N",
    className: "cls-11-privacy-p1",
    d: "M749,292.98c6.44-.07,4.3,8.37,4.67,14.37h-3.7c-.52-4.22,1.7-11.63-2.52-11.63s-2.52,7.19-2.89,11.63h-3.7l-.07-14.07h3.48c.15.89-.07,2.07.22,2.81.89-1.93,2.07-3.04,4.52-3.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-2",
    "data-name": "X",
    className: "cls-11-privacy-p1",
    d: "M765.37,297.13c.07-2.15-5.19-2.52-5.26-.3,1.11,3.41,8.74.52,8.81,6.37.07,6.15-12.15,5.63-12.74.67l3.19-.52c.3,1.41,1.48,1.85,3.26,1.85,2.44.59,4.22-2.22,1.78-3.04-3.19-1.04-7.56-.81-7.7-4.89-.15-5.93,11.41-5.48,11.93-.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-5",
    "data-name": "M",
    className: "cls-11-privacy-p1",
    d: "M771.89,290.76v-2.74h3.7v2.74h-3.7ZM771.89,307.35v-14.07h3.7v14.07h-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-5",
    "data-name": "L",
    className: "cls-11-privacy-p1",
    d: "M785.96,307.13c-2.67,1.04-6.44.52-6.44-3.11v-8.3h-1.78v-2.44h2l1.11-3.33h2.3v3.33h2.67v2.44h-2.67v7.33c-.07,1.7,1.19,2.3,2.81,1.85v2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-6",
    "data-name": "M",
    className: "cls-11-privacy-p1",
    d: "M788.11,290.76v-2.74h3.7v2.74h-3.7ZM788.11,307.35v-14.07h3.7v14.07h-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "cls-11-privacy-p1",
    d: "M803.15,307.35h-4.37l-5.04-14.07h3.93l3.33,11.11,3.56-11.11h3.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-7",
    "data-name": "O",
    className: "cls-11-privacy-p1",
    d: "M822.18,303.8c-.96,2.22-2.74,3.93-6.07,3.85-4.44-.15-6.59-2.74-6.59-7.41s2.22-7.26,6.67-7.26,6.15,3.33,6.22,8h-9.04c0,2.3.59,4.07,2.89,4.15,1.33,0,2.22-.52,2.52-1.63l3.41.3ZM818.85,298.68c.37-3.41-4.22-4.67-5.19-1.56-.15.44-.3.96-.3,1.56h5.48"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "diamond1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6-privacy-p1",
    d: "M449.66,162.48c3.66-1.29,7.66-1.29,11.32,0l159.8,56.03c1.09.39,1.67,1.59,1.28,2.68-.21.6-.68,1.07-1.28,1.28l-159.8,56.03c-3.67,1.29-7.66,1.29-11.33,0l-159.8-56.04c-1.1-.38-1.68-1.57-1.3-2.67.21-.61.69-1.09,1.3-1.3l159.81-56.01Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "cls-9-privacy-p1",
    d: "M430.23,209.36v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "cls-9-privacy-p1",
    d: "M443.34,213.23c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-9-privacy-p1",
    d: "M445.31,208.62v-2.04h2.17v2.04h-2.17ZM445.31,224.3v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-9-privacy-p1",
    d: "M458.62,221.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM452.3,220.7c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-9-privacy-p1",
    d: "M474.64,211.4c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM469,222.81c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "cls-9-privacy-p1",
    d: "M482.99,211.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM486.52,216.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-privacy-p1",
    d: "M0,374.69h412.88v125.34H0v-125.34Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "privacy-disable-rect",
    d: "M35.32,374.69h342.25v112H35.33v-112Z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "w-2",
    "data-name": "w",
    className: "cls-12-privacy-p1",
    d: "M71.59,421.56l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM69.01,414.84l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-3",
    "data-name": "x",
    className: "cls-12-privacy-p1",
    d: "M79.74,408.39c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM80.35,410.02c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-4",
    "data-name": "x",
    className: "cls-12-privacy-p1",
    d: "M93.32,408.39c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM93.93,410.02c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "z-2",
    "data-name": "z",
    className: "cls-12-privacy-p1",
    d: "M109.55,405.88v-2.04h2.17v2.04h-2.17ZM109.55,421.56v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-5",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M117.29,418.37c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "C-6",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M130.87,418.37c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-3",
    "data-name": "D",
    className: "cls-12-privacy-p1",
    d: "M140.44,408.39c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM140.38,420.2c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "cls-12-privacy-p1",
    d: "M163.87,419.46c-.75,1.49-1.97,2.38-4.07,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.01,1.15-6.72,4.75-6.79,2.17-.07,3.26.95,4.07,2.24,0-.75-.07-1.63.14-2.17h2.04l-.07,18.2h-2.17l.07-7.2ZM160.34,420.14c2.78,0,3.46-2.24,3.46-5.16s-.54-4.96-3.4-4.96-3.12,2.38-3.12,5.09.34,5.02,3.06,5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-2",
    "data-name": "E",
    className: "cls-12-privacy-p1",
    d: "M173.31,421.83c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-2",
    "data-name": "G",
    className: "cls-12-privacy-p1",
    d: "M190.76,419.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM184.44,417.96c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "cls-12-privacy-p1",
    d: "M202.5,410.49c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-7",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M206.85,418.37c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-4",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M216.42,408.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM219.96,413.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "cls-12-privacy-p1",
    d: "M230.96,410.49c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "cls-12-privacy-p1",
    d: "M232.92,421.56v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "cls-12-privacy-p1",
    d: "M248.81,408.66l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "cls-12-privacy-p1",
    d: "M248.88,421.83l4.89-17.99h1.9l-4.89,17.99h-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "cls-12-privacy-p1",
    d: "M263.48,408.39c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM262.94,420.2c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-3",
    "data-name": "z",
    className: "cls-12-privacy-p1",
    d: "M270.88,405.88v-2.04h2.17v2.04h-2.17ZM270.88,421.56v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "cls-12-privacy-p1",
    d: "M275.7,415.99v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-3",
    "data-name": "G",
    className: "cls-12-privacy-p1",
    d: "M292.27,419.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM285.96,417.96c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-3",
    "data-name": "H",
    className: "cls-12-privacy-p1",
    d: "M304.22,408.39c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-4",
    "data-name": "H",
    className: "cls-12-privacy-p1",
    d: "M317.8,408.39c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-3",
    "data-name": "E",
    className: "cls-12-privacy-p1",
    d: "M329.14,421.83c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-4",
    "data-name": "G",
    className: "cls-12-privacy-p1",
    d: "M346.59,419.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM340.28,417.96c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "cls-12-privacy-p1",
    d: "M352.23,421.56v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "E-4",
    "data-name": "E",
    className: "cls-12-privacy-p1",
    d: "M129.04,451.17c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-2",
    "data-name": "F",
    className: "cls-12-privacy-p1",
    d: "M144.72,437.72c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM144.18,449.54c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-5",
    "data-name": "x",
    className: "cls-12-privacy-p1",
    d: "M156.26,437.72c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM156.88,439.35c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-5",
    "data-name": "G",
    className: "cls-12-privacy-p1",
    d: "M173.65,448.45c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM167.33,447.3c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-8",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M181.66,447.7c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-5",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M191.23,437.72c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM194.76,443.22c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "F-3",
    "data-name": "F",
    className: "cls-12-privacy-p1",
    d: "M212.62,437.72c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM212.08,449.54c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "cls-12-privacy-p1",
    d: "M226.13,439.83c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-4",
    "data-name": "D",
    className: "cls-12-privacy-p1",
    d: "M233.26,437.72c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM233.2,449.54c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-3",
    "data-name": "A",
    className: "cls-12-privacy-p1",
    d: "M246.57,439.42c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-6",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M259.07,437.72c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM262.6,443.22c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "cls-12-privacy-p1",
    d: "M275.02,441.19c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "cls-12-privacy-p1",
    d: "M287.24,441.19c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-privacy-p1",
    d: "M480,374.69h412.88v125.34h-412.88v-125.34Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "privacy-disable-rect",
    d: "M515.32,374.69h342.25v112h-342.24v-112Z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "cls-12-privacy-p1",
    d: "M533.67,417.47c8.01-.48,14.67.54,14.46,8.28-.2,5.3-2.92,8.56-8.22,8.56h-6.25v-16.84ZM535.91,432.48c6.04.54,9.91-1.09,9.91-6.72s-4.07-6.86-9.91-6.45v13.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-7",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M556.01,421.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM559.54,426.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "cls-12-privacy-p1",
    d: "M569.65,418.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-4",
    "data-name": "z",
    className: "cls-12-privacy-p1",
    d: "M571.22,418.63v-2.04h2.17v2.04h-2.17ZM571.22,434.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-5",
    "data-name": "H",
    className: "cls-12-privacy-p1",
    d: "M582.89,421.14c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-8",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M595.32,421.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM598.85,426.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "C-9",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M612.91,431.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-5",
    "data-name": "z",
    className: "cls-12-privacy-p1",
    d: "M617.32,418.63v-2.04h2.17v2.04h-2.17ZM617.32,434.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "cls-12-privacy-p1",
    d: "M635.31,422.84c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-9",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M648.15,421.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM651.68,426.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-2",
    "data-name": "ap",
    className: "cls-12-privacy-p1",
    d: "M661.8,418.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-4",
    "data-name": "ah",
    className: "cls-12-privacy-p1",
    d: "M669.47,423.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-6",
    "data-name": "G",
    className: "cls-12-privacy-p1",
    d: "M679.38,431.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM673.07,430.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "cls-12-privacy-p1",
    d: "M697.65,422.84c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-10",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M710.48,421.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM714.01,426.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "G-7",
    "data-name": "G",
    className: "cls-12-privacy-p1",
    d: "M733.63,431.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM727.32,430.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-6",
    "data-name": "H",
    className: "cls-12-privacy-p1",
    d: "M745.59,421.14c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-6",
    "data-name": "x",
    className: "cls-12-privacy-p1",
    d: "M756.99,421.14c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM757.6,422.77c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "z-6",
    "data-name": "z",
    className: "cls-12-privacy-p1",
    d: "M773.22,418.63v-2.04h2.17v2.04h-2.17ZM773.22,434.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H-7",
    "data-name": "H",
    className: "cls-12-privacy-p1",
    d: "M784.9,421.14c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-7",
    "data-name": "z",
    className: "cls-12-privacy-p1",
    d: "M792.17,418.63v-2.04h2.17v2.04h-2.17ZM792.17,434.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-10",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M799.91,431.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-8",
    "data-name": "z",
    className: "cls-12-privacy-p1",
    d: "M804.32,418.63v-2.04h2.17v2.04h-2.17ZM804.32,434.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-8",
    "data-name": "G",
    className: "cls-12-privacy-p1",
    d: "M817.63,431.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM811.31,430.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-11",
    "data-name": "C",
    className: "cls-12-privacy-p1",
    d: "M825.64,431.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-11",
    "data-name": "B",
    className: "cls-12-privacy-p1",
    d: "M835.22,421.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM838.75,426.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPhase1);
export default __webpack_public_path__ + "static/media/Privacy_Phase_1.e691cd739cd5ff594a12219598ad334b.svg";
export { ForwardRef as ReactComponent };